import React from 'react'
import { FastField, Field, useFormikContext } from 'formik'
import { Box, Typography } from '@mui/material'
import { CustomRadio, CustomRadioGroup, CustomTextField, CustomCheckboxWithoutInitialValue } from 'src/form'

import { Section, SubSection } from '../common/Section'
import { IntakeNoteComprehensiveFormType } from './IntakeNoteComprehensiveFormSchema'

export function MentalHealthTreatmentHistoryForm() {
  const { values } = useFormikContext<IntakeNoteComprehensiveFormType>()
  return (
    <Section title="Mental Health Treatment History" helperText="Box checked if participant endorses.">
      <SubSection>
        <Field
          fullWidth
          component={CustomCheckboxWithoutInitialValue}
          name="MENTAL_HEALTH_TREATMENT_HISTORY.SEEN_MENTAL_HEALTH_PROFESSIONAL_IN_PAST"
          label="Participant has seen a mental health professional in the past."
        />
        {values.MENTAL_HEALTH_TREATMENT_HISTORY.SEEN_MENTAL_HEALTH_PROFESSIONAL_IN_PAST && (
          <FastField
            fullWidth
            component={CustomTextField}
            name="MENTAL_HEALTH_TREATMENT_HISTORY.CARE_DETAILS"
            label="Care details"
            multiline
            minRows={4}
          />
        )}
        <Field
          fullWidth
          component={CustomCheckboxWithoutInitialValue}
          name="MENTAL_HEALTH_TREATMENT_HISTORY.HOSPITALIZED_FOR_MENTAL_HEALTH"
          label="Participant has been hospitalized for mental health reasons."
        />
        {values.MENTAL_HEALTH_TREATMENT_HISTORY.HOSPITALIZED_FOR_MENTAL_HEALTH && (
          <FastField
            fullWidth
            component={CustomTextField}
            name="MENTAL_HEALTH_TREATMENT_HISTORY.HOSPITALIZATION_DETAILS"
            label="Hospitalization details"
            multiline
            minRows={4}
          />
        )}

        <Box mt={2}>
          <Typography variant="h6" color="textSecondary">
            Trauma
          </Typography>
          <Field component={CustomRadioGroup} name="MENTAL_HEALTH_TREATMENT_HISTORY.HISTORY_OF_TRAUMA">
            <CustomRadio label="Participant reports not having history of or exposure to trauma." value="reports_no" />
            <CustomRadio label="Participant reports having history of or exposure to trauma." value="reports_yes" />
          </Field>
          {values.MENTAL_HEALTH_TREATMENT_HISTORY.HISTORY_OF_TRAUMA === 'reports_yes' && (
            <FastField
              component={CustomTextField}
              name="MENTAL_HEALTH_TREATMENT_HISTORY.TRAUMA_DETAILS"
              label="Trauma details"
              fullWidth
              multiline
              minRows={4}
            />
          )}
        </Box>
      </SubSection>
    </Section>
  )
}
